import React, { useState } from "react";
import "./FloatingButtons.css";
import { FaWhatsapp, FaPhoneAlt, FaTimes } from "react-icons/fa";

const FloatingButtons = () => {
  const [open, setOpen] = useState(true);

  return (
    <div className="floating-container">

      {/* Main Toggle */}
      <div className="fab main-btn" onClick={() => setOpen(!open)}>
        <FaTimes />
      </div>

      {/* Action Buttons */}
      <div className={`fab-group ${open ? "show" : ""}`}>
        
        {/* WhatsApp */}
        <a
          href="https://wa.me/919010060007"
          target="_blank"
          rel="noreferrer"
          className="fab whatsapp"
        >
          <FaWhatsapp />
        </a>

        {/* Call */}
        <a href="tel:9010060007" className="fab call">
          <FaPhoneAlt />
        </a>

      </div>
    </div>
  );
};

export default FloatingButtons;